/* Ganimarka product-card colour swatches (Peak Performance behaviour).
   Per card we read <script data-gm-card> = {colors:[{c,vid,price,cprice,pct,url,imgs:[main,2nd],sizes:[{s,a}]}]}.
   - Hover a swatch  -> tile image (+ 2nd image on card-hover), price (+ struck compare-at),
                        sale badge and available sizes preview that colour.
   - Click a swatch  -> SELECT that colour (sticky); does NOT navigate.
   - Leave the card  -> revert to the selected colour (or the default colour).
   The card rating is server-rendered (hdt-pr-card-rating.liquid, GAMA-70); no Judge.me hydration here. */
(function () {
  if (window.__gmCards) return;
  window.__gmCards = true;

  function imgs(card) {
    return {
      main: card.querySelector('.hdt-card-product__media--main'),
      hover: card.querySelector('.hdt-card-product__media--hover')
    };
  }
  function setImg(el, url) {
    if (!el || !url) return;
    el.setAttribute('src', url);
    if (el.hasAttribute('srcset')) el.setAttribute('srcset', url);
    el.removeAttribute('data-src');
  }
  function priceWrap(card) {
    return card.querySelector('.hdt-card-product__price-wrapper');
  }
  function sizeWrap(card) {
    return card.querySelector('.hdt-size-list .hdt-size-list-wrapper');
  }
  // href with ?variant=vid set (replaced if present), other params (_pos/_sid/_ss, market prefix) kept.
  function withVariant(href, vid) {
    try {
      var u = new URL(href, location.origin);
      u.searchParams.set('variant', vid);
      return u.pathname + u.search + u.hash;
    } catch (e) { return href; }
  }
  function links(card) {
    return card.querySelectorAll('[data-pr-url]');
  }
  // update sale price + (optional) struck compare-at price for the chosen colour
  function setPrice(card, co) {
    var wrap = priceWrap(card);
    if (!wrap || !co.price) return;
    var sale = wrap.querySelector('.hdt-price .hdt-money') || wrap.querySelector('.hdt-money');
    if (sale) sale.textContent = co.price;
    var cmp = wrap.querySelector('.hdt-compare-at-price');
    if (co.cprice) {
      if (!cmp) {
        var list = wrap.querySelector('.hdt-price__list') || wrap;
        cmp = document.createElement('hdt-compare-at-price');
        cmp.className = 'hdt-compare-at-price';
        cmp.innerHTML = '<span class="hdt-money"></span>';
        list.insertBefore(cmp, list.firstChild);
      }
      var cm = cmp.querySelector('.hdt-money'); if (cm) cm.textContent = co.cprice;
      cmp.removeAttribute('hidden');
    } else if (cmp) {
      cmp.setAttribute('hidden', '');
    }
  }

  // GAMA-177: the tile badge (gm-card-badge.liquid) follows the chosen colour. co.pct is that colour's
  // sale-label number, computed in card-product1.liquid by gm-sale-pct (tier tag / floored real discount)
  // and null unless the colour's variant has a struck price — so a −N% badge can never sit next to a
  // price row without the crossed-out price. A colour without a reduction gets the server-rendered badge
  // back (New / Only N left / Bestseller) unless that one was a sale badge, which is then hidden.
  // "Sold out" badges and cards whose colour is not in the JSON (pct undefined) are left alone.
  function badgeWrap(card) {
    return card.querySelector('.hdt-card-product__media .gm-card-badge');
  }
  function setBadge(card, co) {
    if (!co || co.pct === undefined) return;
    var wrap = badgeWrap(card);
    var item = wrap && wrap.querySelector('.gm-card-badge__item');
    if (item && item.classList.contains('gm-card-badge--soldout')) return;
    if (card.__badge0 === undefined) card.__badge0 = wrap ? wrap.innerHTML : null;  // server badge (default colour)
    if (co.pct) {
      if (!wrap) {
        var media = card.querySelector('.hdt-card-product__media');
        if (!media) return;
        wrap = document.createElement('div');
        wrap.className = 'hdt-badge__wrapp gm-card-badge';
        var pcm = media.querySelector('hdt-product-card-media');
        media.insertBefore(wrap, pcm ? pcm.nextSibling : media.firstChild);
      }
      wrap.innerHTML = '<span class="hdt-badge gm-card-badge__item gm-card-badge--sale">\u2212' + co.pct + '%</span>';
      wrap.style.display = '';
    } else if (wrap) {
      if (card.__badge0 && card.__badge0.indexOf('gm-card-badge--sale') < 0) {
        wrap.innerHTML = card.__badge0;
        wrap.style.display = '';
      } else {
        wrap.style.display = 'none';
      }
    }
  }

  // mobile PLP tile carousel (card-product-media.liquid). On colour-grouped
  // products [data-gm-grouped] the gallery is rebuilt to show ONLY the chosen
  // colour's own images (1 or 2, deduped) + the CTA slide — never padded from
  // another colour, and reset to the first slide. Non-grouped tiles have no
  // swatches so their carousel (up to 3 of the product's own media) is left be.
  function uniqUrls(arr) {
    var out = [];
    for (var i = 0; i < (arr || []).length; i++) {
      var u = arr[i];
      if (u && out.indexOf(u) < 0) out.push(u);
    }
    return out;
  }
  function sized(u) {
    if (!u) return u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=720';
  }
  function rebuildGroupedCarousel(card, co) {
    var car = card.querySelector('.hdt-card-carousel[data-gm-grouped]');
    if (!car) return;
    var track = car.querySelector('.hdt-card-carousel__track');
    if (!track) return;
    var urls = uniqUrls(co.imgs);
    if (!urls.length && co.vimg) urls = [co.vimg];
    if (!urls.length) return;
    // cap to the tile_gallery_count theme setting (rendered on the element)
    var cap = parseInt(car.getAttribute('data-gm-tile-count'), 10);
    if (cap > 0) urls = urls.slice(0, cap);
    var href = co.url || (function () { var a = card.querySelector('[data-pr-url]'); return a ? a.getAttribute('href') : '#'; })();
    var slides = '';
    urls.forEach(function (u) {
      slides += '<a class="hdt-card-carousel__slide" href="' + href + '" data-pr-url tabindex="-1">' +
                '<img class="hdt-card-carousel__img" src="' + sized(u) + '" loading="lazy" alt=""></a>';
    });
    slides += '<a class="hdt-card-carousel__slide hdt-card-carousel__slide--cta" href="' + href + '" data-pr-url tabindex="-1">' +
              '<img class="hdt-card-carousel__img" src="' + sized(urls[0]) + '" loading="lazy" alt="">' +
              '<span class="hdt-card-carousel__cta"><span>See product details</span></span></a>';
    track.innerHTML = slides;
    track.scrollLeft = 0;
    var dotsWrap = car.querySelector('.hdt-card-carousel__dots');
    if (dotsWrap) {
      var dh = '';
      for (var k = 0; k <= urls.length; k++) dh += '<span class="hdt-card-carousel__dot' + (k === 0 ? ' is-active' : '') + '"></span>';
      dotsWrap.innerHTML = dh;
    }
  }

  function apply(card, co) {
    var im = imgs(card);
    var primary = (co.imgs && co.imgs[0]) || co.vimg;
    var second = (co.imgs && co.imgs[1]) || primary;
    setImg(im.main, primary);
    setImg(im.hover, second);
    rebuildGroupedCarousel(card, co);
    setPrice(card, co);
    setBadge(card, co);
    var sw = sizeWrap(card);
    if (sw && co.sizes && co.sizes.length) {
      sw.innerHTML = co.sizes.map(function (s) {
        return '<span class="hdt-size-list-item"' + (s.a ? '' : ' unavailable') + '>' + s.s + '</span>';
      }).join('');
    }
    links(card).forEach(function (a) {
      if (a.__b == null) a.__b = a.getAttribute('href') || '';  // keep search's _pos/_sid/_ss (GAMA-114)
      a.setAttribute('href', co.url || a.__b);
    });
  }

  function snapshot(card) {
    var im = imgs(card), pw = priceWrap(card), sw = sizeWrap(card);
    return {
      mainSrc: im.main && im.main.getAttribute('src'), mainSet: im.main && im.main.getAttribute('srcset'),
      hoverSrc: im.hover && im.hover.getAttribute('src'), hoverSet: im.hover && im.hover.getAttribute('srcset'),
      priceHTML: pw && pw.innerHTML, sizes: sw && sw.innerHTML,
      co: card.__sel || null
    };
  }
  function revert(card) {
    var d = card.__def; if (!d) return;
    var im = imgs(card);
    if (im.main) { if (d.mainSrc != null) im.main.setAttribute('src', d.mainSrc); if (d.mainSet != null) im.main.setAttribute('srcset', d.mainSet); }
    if (im.hover) { if (d.hoverSrc != null) im.hover.setAttribute('src', d.hoverSrc); if (d.hoverSet != null) im.hover.setAttribute('srcset', d.hoverSet); }
    var pw = priceWrap(card); if (pw && d.priceHTML != null) pw.innerHTML = d.priceHTML;
    var sw = sizeWrap(card); if (sw && d.sizes != null) sw.innerHTML = d.sizes;
    if (d.co) rebuildGroupedCarousel(card, d.co);
    setBadge(card, d.co || card.__defCo);
    links(card).forEach(function (a) { if (a.__b != null) a.setAttribute('href', a.__b); });
  }

  function init(card) {
    if (card.__gm) return;
    var radios = card.querySelectorAll(
      'wrapp-hdt-color-list input[type="radio"][data-vid], .hdt-color-list input[type="radio"][data-vid]'
    );
    if (!radios.length) return;
    card.__gm = true;

    var byColor = {};
    var force = null;
    var el = card.querySelector('script[data-gm-card]');
    if (el) { try { var j = JSON.parse(el.textContent); force = j.force || null; (j.colors || []).forEach(function (c) { byColor[c.c] = c; }); } catch (e) {} }

    var baseA = card.querySelector('[data-pr-url]');
    var base = baseA ? (baseA.getAttribute('href') || location.pathname) : location.pathname;
    var radioByColor = {};
    function markSelected(r) {
      Array.prototype.forEach.call(radios, function (x) {
        var item = x.closest('.hdt-color-list-item');
        if (item) item.classList.toggle('is-gm-selected', x === r);
      });
    }
    function select(co, r) {
      card.__sel = co;
      if (r) { r.checked = true; markSelected(r); }
      apply(card, co);
    }

    Array.prototype.forEach.call(radios, function (r) {
      var color = r.value;
      radioByColor[color] = r;
      var co = byColor[color] || {};
      co.vimg = r.getAttribute('data-vimg');
      if (co.vid == null) co.vid = r.getAttribute('data-vid');
      // disable the theme's own pointerover image-preview so we are the single
      // source of truth (its delegated handler keys on [data-vimg] + label).
      r.removeAttribute('data-vimg');
      // Always derive from the card link: product.url on search/recommendation cards already has a query
      // (_pos/_sid/_ss, sometimes variant=), so the JSON "url" (product_url + '?variant=') can be
      // "…&variant=A?variant=B" and opens the wrong colour (GAMA-114).
      if (co.vid != null) co.url = withVariant(base, co.vid);
      var label = card.querySelector('label[for="' + (r.id || '') + '"]') || r.nextElementSibling;
      var target = label || r;
      target.addEventListener('mouseenter', function () { apply(card, co); });
      target.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        select(co, r);
      }, true);
    });

    // Show the default colour's price on load — incl. the struck compare-at for
    // discounts, which the theme suppresses on cards when colours have different
    // prices (price_varies). Then snapshot this as the revert baseline.
    // The checked radio is the colour of selected_or_first_available_variant
    // (color-list.liquid, GAMA-177) — the variant the server price row and badge
    // already show, so this only re-asserts them (and re-adds a struck price the
    // theme dropped), never swaps to a colour without one.
    var defR = null;
    Array.prototype.forEach.call(radios, function (r) { if (r.checked) defR = r; });
    if (!defR) defR = radios[0];
    var defCo = defR && byColor[defR.value];
    card.__defCo = defCo || null;
    if (defCo) {
      setPrice(card, defCo);
      setBadge(card, defCo);
      // Align the pre-interaction card-hover with the swatch logic: show the
      // DEFAULT colour's own 2nd image (imgs[1]). The liquid-rendered hover
      // (card-product-media next_media) is picked from global media order and can
      // belong to another colour — that's the "hover shows a different variation"
      // bug. Fall back to the colour's own main image (no swap) when it has only
      // one photo, so we never show another colour's image.
      var defIm = imgs(card);
      var defSecond = (defCo.imgs && defCo.imgs[1]) || (defCo.imgs && defCo.imgs[0]) || defCo.vimg;
      if (defIm.hover && defSecond) setImg(defIm.hover, defSecond);
    }
    card.__def = snapshot(card);

    // Shop-by-colour: pre-select the collection's colour on this tile.
    if (force && byColor[force] && radioByColor[force]) {
      select(byColor[force], radioByColor[force]);
      card.__def = snapshot(card);
    }

    var list = card.querySelector('wrapp-hdt-color-list, .hdt-color-list');
    if (list) list.addEventListener('mouseleave', function () {
      if (card.__sel) apply(card, card.__sel); else revert(card);
    });
  }

  function scan() { document.querySelectorAll('.hdt-card-product').forEach(init); }
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  try { new MutationObserver(function () { scan(); }).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
})();
